export type SsoProvider ="Google" | "Microsoft" | "Signicat";

export const invokeSsoLoginAsync = (provider: SsoProvider): void => {
    window.location.href = `/api/Sso/${provider}`;
};